import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CompletionRateFilter, ErrorLogDto, IProductRates, PolicyStatus } from 'admiral-core';
import { AuthAction } from '@/store/AuthModule';

export const BASE_STORAGE_URL =
  process.env.VUE_APP_NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.host}/api`
    : `${window.location.protocol}//${window.location.host.replace('8080', '4000')}/storage`;

export const BASE_URL =
  process.env.VUE_APP_NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.host}/api`
    : `${window.location.protocol}//${window.location.host.replace('8080', '4000')}/api`;

export const SOCKET_URL =
  process.env.VUE_APP_NODE_ENV === 'production'
    ? `${window.location.host}`
    : `${window.location.host.replace('8080', '4000')}`;

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers['x-requested-with'] = 'XMLHttpRequest';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      await window.app.$store.dispatch(`AuthModule/${AuthAction.Logout}`);
    }
    return Promise.reject(error);
  },
);

export class AdmiralApi {
  static getProductRates(filter?: CompletionRateFilter): Promise<AxiosResponse> {
    if (!filter) {
      filter = {};
    }
    filter.status = [PolicyStatus.OPEN, PolicyStatus.SUBMITTED];

    return AdmiralApi.apiCall<IProductRates>({
      url: `${BASE_URL}/product/rates`,
      method: 'POST',
      data: filter,
    });
  }

  static logError(errorLog: ErrorLogDto) {
    return AdmiralApi.apiCall({
      url: `${BASE_URL}/log`,
      method: 'POST',
      data: errorLog,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static apiCall<T = any>(options: AxiosRequestConfig) {
    return axios.request<T>(options);
  }
}
